import { render, staticRenderFns } from "./CateringPrep.vue?vue&type=template&id=208e7de5&scoped=true"
import script from "./CateringPrep.vue?vue&type=script&lang=js"
export * from "./CateringPrep.vue?vue&type=script&lang=js"
import style0 from "./CateringPrep.vue?vue&type=style&index=0&id=208e7de5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e7de5",
  null
  
)

export default component.exports